<template>
  <SectionContentRedFlagGutHealth v-bind="$attrs" />
</template>

<script setup>
defineBuilderComponent({
  friendlyName: 'Content - Red Flag Gut Health',
  inputs: [
    {
      name: 'badgeNumber',
      type: 'text',
      defaultValue: '3'
    },
    {
      name: 'badgeText',
      type: 'text',
      defaultValue: 'Red Flag No. 3'
    },
    {
      name: 'title',
      type: 'richText',
      defaultValue: 'Inflammation Starts in the Gut — Men Pay the Price First'
    },
    {
      name: 'introContent',
      type: 'richText',
      defaultValue: `<p>Most men don't realize how much their gut influences their entire body.</p>
<p>A compromised gut can lead to:</p>
<ul>
  <li>Chronic inflammation</li>
  <li>Low energy</li>
  <li>Poor nutrient absorption</li>
  <li>Brain fog</li>
  <li>Hormonal imbalance</li>
  <li>Digestive discomfort</li>
</ul>
<p>And here's the kicker:</p>`
    },
    {
      name: 'stainImageSrc',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp', 'svg'],
      defaultValue: '/assets/images/red-flag-gut-stain.png'
    },
    {
      name: 'calloutTitle',
      type: 'text',
      defaultValue: 'Most Conventional Coffee Is Gut-Hostile'
    },
    {
      name: 'calloutContent',
      type: 'richText',
      defaultValue: `<p><strong>Most conventional coffee is highly acidic (pH 4.8–5.1), which can irritate the gut.</strong><sup>19</sup></p>
<p>Lifeboost's low-acid coffee?</p>
<ul>
  <li><strong>Light roasts average pH 5.1–5.8.</strong></li>
  <li><strong>Dark roasts average pH 6.5–6.8 (nearly as alkaline as water).</strong></li>
</ul>
<p>That means smoother digestion, less irritation, and a gut-friendly daily ritual.</p>
<p>Pair that with probiotics and sodium butyrate, a short-chain fatty acid shown to reduce inflammation and support gut lining integrity, and you have a powerful foundation for gut and immune health.</p>`
    },
    {
      name: 'calloutAsideImageSrc',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp', 'svg'],
      defaultValue: '/assets/images/red-flag-gut-ph-scale.png'
    },
    {
      name: 'calloutAsideImageAlt',
      type: 'text',
      defaultValue: 'Coffee pH scale infographic comparing light and dark roast acidity'
    },
    {
      name: 'outroContent',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'showDivider',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'paddingBottom',
      type: 'text',
      enum: ['default', 'reduced'],
      defaultValue: 'reduced'
    },
    {
      name: 'paddingTop',
      type: 'text',
      enum: ['default', 'reduced'],
      defaultValue: 'default'
    }
  ]
})
</script>
